/**
 * Bundle Collection Tracking
 * Mirrors the _bundle_from_upsell / _bundle_from_menu pattern in buy-buttons.liquid.
 *
 * 1. Collection page – appends ?ref=single-collection-bundle to every link
 *    inside .bundle-pinned-card so the source survives navigation to the PDP.
 * 2. PDP – if that ref param is present, sets a cart attribute
 *    _bundle_from_collection via /cart/update.js so Shopify Flow can tag
 *    the resulting order (same approach as _bundle_from_menu).
 */
(() => {
  // 1. Collection page: tag every bundle card link with the ref param
  document.querySelectorAll('.bundle-pinned-card a[href*="/products/"]').forEach(a => {
    const url = new URL(a.href, location.origin);
    url.searchParams.set('ref', 'single-collection-bundle');
    a.href = url;
  });

  // 2. PDP: set cart attribute if coming from the collection bundle card
  if (new URLSearchParams(location.search).get('ref') === 'single-collection-bundle') {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _bundle_from_collection: 'true' } })
    });
  }
})();
